import Vue from 'vue'

const showLoading = (el, binding, delay) => {
  Vue.nextTick(() => {
    const loadingDom = el.getElementsByClassName('custom-loading')
    if (binding.value) {
      if (!(el.timer || loadingDom.length)) {
        el.timer = setTimeout(() => {
          let loadingDom = document.createElement('div')
          let loadingDomChild = document.createElement('div')
          loadingDomChild.setAttribute('class', 'custom-loading-child')
          loadingDom.setAttribute('class', 'custom-loading')
          el.style.position = 'relative'
          loadingDom.appendChild(loadingDomChild)
          el.appendChild(loadingDom)
        }, delay)
      }
    } else {
      if (loadingDom.length) {
        el.removeChild(loadingDom[loadingDom.length - 1])
        el.style.position = 'unset'
      }
      let timer = el.timer
      if (timer) {
        clearTimeout(timer)
        delete el.timer
      }
    }
  })
}

export default (Vue) => {
  Vue.directive('custom-loading', {
    bind: (el, binding) => {
      showLoading(el, binding, 300)
    },
    update: (el, binding) => {
      showLoading(el, binding, 300)
    }
  })
}
